import { supabase } from './supabaseClient'

export const CREDIT_PRICES = {
  merge: 2,
  email: 5,
  address: 11,
  phone: 11,
  aiChatReply: 10
}

export const CREDIT_DOLLAR_RATE = 0.004

export function getOrgId(orgData) {
  return orgData?.organizations?.org_id || orgData?.org_id || null
}

export async function getUsageCredits(orgData) {
  const usage = await getUsage(orgData)
  return usage.credits
}

export async function getUsage(orgData) {
  const orgId = getOrgId(orgData)
  if (!supabase || !orgId) return { credits: 0, allowance: 0 }

  const { data, error } = await supabase
    .from('usage')
    .select('credits, allowance')
    .eq('id', orgId)
    .maybeSingle()

  if (error) throw error
  return {
    credits: Number(data?.credits || 0),
    allowance: Number(data?.allowance || 0)
  }
}

export async function addUsageCredits(orgData, credits) {
  const orgId = getOrgId(orgData)
  const creditsToAdd = Number(credits || 0)
  if (!supabase || !orgId || creditsToAdd <= 0) return null

  const currentCredits = await getUsageCredits(orgData)
  const nextCredits = currentCredits + creditsToAdd

  const { count, error } = await supabase
    .from('usage')
    .update({ credits: nextCredits }, { count: 'exact' })
    .eq('id', orgId)

  if (error) throw error
  if (count === 0) {
    const { error: insertError } = await supabase
      .from('usage')
      .insert({ id: orgId, credits: nextCredits })

    if (insertError) throw insertError
  }

  return nextCredits
}

export function formatUsageDollars(credits) {
  const dollars = Number(credits || 0) * CREDIT_DOLLAR_RATE
  return dollars.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}
